var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12C19.5 7.58172 15.9183 4 11.5 4C7.08172 4 3.5 7.58172 3.5 12C3.5 16.4183 7.08172 20 11.5 20C15.9183 20 19.5 16.4183 19.5 12Z",
    fill: "#23FFB0",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5H18V6H19.5V7.5H21V16.5H19.5V18H18V19.5H16.5V21H7.5V19.5H6V18H4.5V16.5H3V7.5H4.5V6H6V4.5H7.5V3H16.5V4.5Z",
    fill: "#FCFF62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0073 17V16H10.0054V15H9.00439V14H8.00244V13H7.00146V11H8.00244V10H9.00439V9H10.0054V8H11.0073V7H13.0054V8H14.0063V9H15.0063V10H16.0024V11H16.9985V13H16.0024V14H15.0063V15H14.0063V16H13.0054V17H11.0073Z",
    fill: "#1F1F1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/Rewards.e3c6445d8455f32ed8426c323a8854c2.svg";
export { ForwardRef as ReactComponent };